import React, { useState } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from "./img/logo-celerity-header.png";
import logodtv from "./img/logo-directvgo-header.png";

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({ open: false, message: "" });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'puntonet';

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({ open: false, message: "" })

    api.userPassLogin({ username, password },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }


  return (
    <>
      <div className="global-header">

        <div className="puntonet-header">
          <img src={logo} alt="PuntoNet" />
        </div>
        <div className="puntonet-header-dtv">
          <img src={logodtv} alt="PuntoNet" />
        </div>

      </div>
      <Form onSubmit={(event) => onSubmit(event)} className="puntonet-login">
        <div className="puntonet-wrapper">
          <div className="puntonet-form-group">
            <div className="puntonet-form-group-inner">
              <div className="puntonet-form-content">
                <div className="puntonet-login-form">
                  <div className="puntonet-title">
                    <h3>{translate("LoginTitle")}</h3>
                    <p className="puntonet-login-subtitle">{translate("LoginSubtitle")}</p>
                  </div>
                  <div className="puntonet-form-container">
                    <label>{translate("PlaceholderUserNameLabel")}</label>
                    <Input
                      disabled={onLogin}
                      placeholder={translate("PlaceholderUserName")}
                      onChange={(e) => setUsername(e.target.value)}
                      required={true}
                      tabIndex={1}
                      type="text"
                      autoCorrect="off"
                      autoCapitalize="none"
                      name="login"
                      id="login"
                    />
                  </div>
                  <div className="puntonet-form-container">
                    <label>{translate("PlaceholderPasswordLabel")}</label>
                    <Input
                      required={true}
                      disabled={onLogin}
                      placeholder={translate("PlaceholderPassword")}
                      onChange={(e) => setPassword(e.target.value)}
                      tabIndex={1}
                      type="password"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="password"
                      name="login"
                    />
                  </div>
                  <div className="puntonet-options">
                    <div className="puntonet-forgotPassword"><a href="https://directvgo.celerity.ec/forgot">{translate("forgotPassword")}</a></div>
                  </div>
                  <div className="puntonet-button">
                    {!onLogin ? (
                      <button type="submit" disabled={!props.turnstileSuccess}>
                        <span className="puntonet-enter-text">
                          {translate("ButtonEnter")}
                        </span>
                      </button>
                    ) : (
                      <Progress animated color="danger" value={100} />
                    )}
                  </div>
                  <div className="messages-container">
                    <Alert
                      color="danger"
                      id="error-message"
                      isOpen={error.open}
                      toggle={() => setError({ open: false })}
                    >
                      {error.message}
                    </Alert>
                  </div>
                  <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
